import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"

type ResolvedPost = {
	id: string
	title: string | null
	postUrl: string
}

export const resolvePostsByUrls = async (urls: string[]): Promise<ResolvedPost[]> => {
	const { data } = await apiClient.post<ResolvedPost[]>("/posts/resolve", {
		urls,
	})
	return data
}

export const useResolvedPostsByUrls = (urls: string[]) => {
	return useQuery({
		queryKey: ["posts", "resolve", urls],
		queryFn: () => resolvePostsByUrls(urls),
		enabled: urls.length > 0,
		staleTime: 1000 * 60 * 5,
	})
}
